import { v4 as uuidv4 } from 'uuid';

export const toDo = [
  {
    id: '1',
    Task: "Trouble with signing up to courses",
    Assigned_To: 'Beltran',
    Assignee: 'Romona',
    Status: 'To-do',
    Priority: 'High',
    color: "#ff0000",
    Due_Date: '25-May-2020',
    comments: 12,
    likes: 34,
  },
  {
    id: '2',
    Task: "Deadline for tasks missing in course",
    Assigned_To: 'Dave',
    Assignee: 'Romona',
    Status: 'To-do',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '26-May-2020',
    comments: 30,
    likes: 56,
  },
  {
    id: '3',
    Task: "Typos on some courses",
    Assigned_To: 'Roman',
    Assignee: 'Romona',
    Status: 'To-do',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '27-May-2020',
    comments: 21,
    likes: 19,
  },
  {
    id: '4',
    Task: "Question for students",
    Assigned_To: 'Roman',
    Assignee: 'Romona',
    Status: 'To-do',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '27-May-2020',
    comments: 11,
    likes: 19,
  },
  {
    id: '5',
    Task: "What do I do if?...",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '23-Aug-2020',
    comments: 2,
    likes: 10,
  },
];

export const inProg = [
  {
    id: '6',
    Task: "I need contact with a class teacher",
    Assigned_To: 'Bondon',
    Assignee: 'Antoinette',
    Status: 'In Progress',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '05-Jan-2021',
    comments: 20,
    likes: 9,
  },
  {
    id: '7',
    Task: "Deadline for tasks missing in course",
    Assigned_To: 'Dave',
    Assignee: 'Romona',
    Status: 'In Progress',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '26-May-2020',
    comments: 11,
    likes: 19,
  },
  {
    id: '8',
    Task: "Something happened to my assignments??",
    Assigned_To: 'Dave',
    Assignee: 'Romona',
    Status: 'In Progress',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '26-May-2020',
    comments: 2,
    likes: 12,
  },
];

export const awaitInfo = [
  {
    id: '19',
    Task: "I need contact with a class teacher",
    Assigned_To: 'Bondon',
    Assignee: 'Antoinette',
    Status: 'In Progress',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '05-Jan-2021',
    comments: 1,
    likes: 0,
  },
  {
    id: '20',
    Task: "I do not know what to do...",
    Assigned_To: 'Dave',
    Assignee: 'Romona',
    Status: 'In Progress',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '26-May-2020',
    comments: 2,
    likes: 1,
  },
  {
    id: '21',
    Task: "Please help...",
    Assigned_To: 'Dave',
    Assignee: 'Romona',
    Status: 'In Progress',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '26-May-2020',
    comments: 8,
    likes: 9,
  },
];

export const Done = [
  {
    id: '9',
    Task: "Missed deadline because teacher did not remind",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: 'High',
    color: "#ff0000",
    Due_Date: '23-Aug-2020',
    comments: 1,
    likes: 8,
  },
  {
    id: '10',
    Task: "Note for website developers",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '23-Aug-2020',
    comments: 1,
    likes: 1,
  },
  {
    id: '11',
    Task: "I really enjoyed the Finnish fundamentals course!",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '23-Aug-2020',
    comments: 21,
    likes: 56,
  },
  {
    id: '12',
    Task: "What happens if...",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '23-Aug-2020',
    comments: 22,
    likes: 11,
  },
  {
    id: '13',
    Task: "Note for website developers",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '23-Aug-2020',
    comments: 12,
    likes: 26,
  },
  {
    id: '14',
    Task: "I really enjoyed the health care basics course!",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '23-Aug-2020',
    comments: 30,
    likes: 32,
  },
  {
    id: '15',
    Task: "I need some feedback on my work!",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '23-Aug-2020',
    comments: 12,
    likes: 18,
  },
  {
    id: '16',
    Task: "Thank you!",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '23-Aug-2020',
    comments: 3,
    likes: 2,
  },
  {
    id: '17',
    Task: "I got so interested in this topic now, thanks!!!",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: 'Low',
    color: "#008000",
    Due_Date: '23-Aug-2020',
    comments: 12,
    likes: 22,
  },
  {
    id: '18',
    Task: "Did someone else ...? Help!",
    Assigned_To: 'Gawen',
    Assignee: 'Kai',
    Status: 'Done',
    Priority: "Medium",
    color: "#ffa726",
    Due_Date: '23-Aug-2020',
    comments: 3,
    likes: 1,
  },
];

export const columnsFromBackend = {
    
  [uuidv4()]: {
    title: "Open",
    items: toDo,
  },
  [uuidv4()]: {
    title: "In Progress",
    items: inProg,
  },
  [uuidv4()]: {
    title: "Extra details needed",
    items: awaitInfo,
  },
  [uuidv4()]: {
    title: "Complete",
    items: Done,
  },
};
